import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/demo1/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '20px',
      }}
    >
      <div
        style={{
          maxWidth: '500px',
          background: 'white',
          borderRadius: '12px',
          padding: '40px',
          textAlign: 'center',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
        }}
      >
        <h1
          style={{
            fontSize: '32px',
            marginBottom: '16px',
            color: '#333',
          }}
        >
          Welcome to Demo Slides
        </h1>

        <p
          style={{
            fontSize: '16px',
            color: '#666',
            marginBottom: '32px',
            lineHeight: '1.6',
          }}
        >
          Experience sample slides and features by downloading the app and entering the demo code below.
        </p>

        <div
          style={{
            background: '#f0f0f0',
            padding: '24px',
            borderRadius: '8px',
            marginBottom: '32px',
          }}
        >
          <p
            style={{
              fontSize: '14px',
              color: '#999',
              marginBottom: '12px',
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            Demo Code
          </p>
          <div
            style={{
              fontSize: '36px',
              fontWeight: 'bold',
              color: '#667eea',
              fontFamily: 'monospace',
              letterSpacing: '2px',
            }}
          >
            DEMO1
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            gap: '12px',
            flexDirection: 'column',
          }}
        >
          <a
            href="https://apps.apple.com" // Update with actual App Store link
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              background: '#667eea',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              transition: 'background 0.3s',
              cursor: 'pointer',
            }}
            onMouseOver={(e) => (e.currentTarget.style.background = '#764ba2')}
            onMouseOut={(e) => (e.currentTarget.style.background = '#667eea')}
          >
            Download for iOS
          </a>

          <a
            href="https://play.google.com" // Update with actual Google Play link
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              background: '#667eea',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              transition: 'background 0.3s',
              cursor: 'pointer',
            }}
            onMouseOver={(e) => (e.currentTarget.style.background = '#764ba2')}
            onMouseOut={(e) => (e.currentTarget.style.background = '#667eea')}
          >
            Download for Android
          </a>
        </div>

        <p
          style={{
            fontSize: '13px',
            color: '#999',
            marginTop: '24px',
          }}
        >
          After downloading, use the code <strong>DEMO1</strong> to access sample slides.
        </p>
      </div>
    </div>
  )
}
